export const checkManagerView = (): boolean => location.pathname.startsWith('/manage');
